var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smb-alert',{staticClass:"small text-center",attrs:{"visible":_vm.visible,"closeable":_vm.closeableVal}},[_c('h4',{class:[("text-" + _vm.titleColor)]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }